// extracted by mini-css-extract-plugin
module.exports = {"icon":"ProviderButton_icon__2ZA2N","lwa":"ProviderButton_lwa__11ZMQ"};